import { Field, useFormikContext } from 'formik';

import Input from '@tmh-website/ui/Input';
import type { FormElementThemeColor } from '@tmh-website/ui/FormElements';

import type { BusinessUnitSolutionsWeb2CaseFormValues } from '../BusinessUnitSolutionsWeb2CaseForm.schema';
import { useBusinessUnitSolutionsWeb2CaseForm } from '../BusinessUnitSolutionsWeb2CaseForm.hooks';

type BillingSystemFieldsProps = {
  formElementThemeColor: FormElementThemeColor;
};

export const BillingSystemFields = ({ formElementThemeColor }: BillingSystemFieldsProps): JSX.Element | undefined => {
  const { values } = useFormikContext<BusinessUnitSolutionsWeb2CaseFormValues>();
  const { fieldLabels } = useBusinessUnitSolutionsWeb2CaseForm();

  if (values.question !== 'Billing system') {
    return undefined;
  }

  return (
    <Field
      as={Input}
      themeColor={formElementThemeColor}
      label={fieldLabels.message}
      name='message'
      maxLength={500}
      required
    />
  );
};
